import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faMap } from '@fortawesome/free-solid-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

function redirectToMaps() {
    window.open("https://www.google.com/maps/place/SARL+T.elec/@48.7163621,6.2620207,15z/data=!4m5!3m4!1s0x0:0xa333a8267171cd11!8m2!3d48.7163621!4d6.2620207");
}

function redirectToYoutube() {
    window.open("https://consent.youtube.com/m?continue=https%3A%2F%2Fwww.youtube.com%2Fuser%2F54TELEC%2Fvideos%3Fcbrd%3D1&gl=FR&m=0&pc=yt&cm=2&hl=fr&src=1");
}

function redirectToFacebook() {
    window.open("https://www.facebook.com/t.elec54");
}

function redirectToMail() {
    window.open("mailto:t.elec@hotmail.fr");
}

const Contact = () => (
    <section id="contact" className="bg-light-background dark:bg-dark-background p-6 h-full">
        <h2 className="text-3xl text-center text-light-text dark:text-dark-text pt-5 pb-5">
            Nos réseaux et coordonnées
        </h2>

        <p className="text-center text-light-text dark:text-dark-text max-w-4xl mx-auto px-4 pb-6">
            Vous cherchez un électricien à Nancy ? Contactez T.ELEC pour un devis, une demande d’information ou pour planifier une intervention.
        </p>

        <div className="flex justify-center flex-wrap items-center sm:px-32">
            <div className="flex flex-col justify-center items-center w-1/2 h-52 py-4 group cursor-pointer">
                <FontAwesomeIcon icon={faYoutube} className="w-20 h-20 text-red-600 transition ease-in-out group-hover:-translate-y-1 group-hover:scale-110 duration-300" onClick={redirectToYoutube} />
                <p className="text-center pt-5 text-light-text dark:text-dark-text">Voir nos réalisations sur YouTube</p>
            </div>

            <div className="flex flex-col justify-center items-center w-1/2 h-52 py-4 group cursor-pointer">
                <FontAwesomeIcon icon={faFacebook} className="w-20 h-20 text-blue-900 transition ease-in-out group-hover:-translate-y-1 group-hover:scale-110 duration-300" onClick={redirectToFacebook} />
                <p className="text-center pt-5 text-light-text dark:text-dark-text">Suivre notre actualité sur Facebook</p>
            </div>

            <div className="flex flex-col justify-center items-center w-1/3 max-sm:w-1/2 h-52 py-4 group cursor-pointer">
                <FontAwesomeIcon icon={faMap} className="w-20 h-20 text-green-500 transition ease-in-out group-hover:-translate-y-1 group-hover:scale-110 duration-300" onClick={redirectToMaps} />
                <p className="text-center pt-5 text-light-text dark:text-dark-text">Nous localiser sur Google Maps</p>
            </div>

            <div className="flex flex-col justify-center items-center w-1/3 max-sm:w-1/2 h-52 py-4 group cursor-pointer">
                <a href="tel:+33624342947" className="flex flex-col items-center">
                    <FontAwesomeIcon icon={faPhone} className="w-20 h-20 dark:text-dark-text transition ease-in-out group-hover:-translate-y-1 group-hover:scale-110 duration-300" />
                    <p className="text-center pt-5 text-light-text dark:text-dark-text">Nous appeler</p>
                </a>
            </div>

            <div className="flex flex-col justify-center items-center w-1/3 max-sm:w-1/2 h-52 py-4 group cursor-pointer">
                <button type="button" onClick={redirectToMail} className="flex flex-col items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="w-20 h-20 dark:text-dark-text transition ease-in-out group-hover:-translate-y-1 group-hover:scale-110 duration-300" />
                    <p className="text-center pt-5 text-light-text dark:text-dark-text">Nous écrire par email</p>
                </button>
            </div>
        </div>
    </section>
)

export default Contact;